/** Notification and error handling model interfaces and constants. */
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

/** Notification type */
export type NotificationType = 'success' | 'error' | 'warning' | 'info';

/** Notification configuration */
export interface NotificationConfig {
  duration?: number;
  horizontalPosition?: MatSnackBarHorizontalPosition;
  verticalPosition?: MatSnackBarVerticalPosition;
  action?: string;
  panelClass?: string[];
}

/** Default durations by notification type */
export const NOTIFICATION_DEFAULT_DURATIONS: Record<NotificationType, number> = {
  success: 3000,
  error: 5000,
  warning: 5000,
  info: 3000,
};

/** Default CSS classes by notification type */
export const NOTIFICATION_TYPE_CLASSES: Record<NotificationType, string[]> = {
  success: ['notification-success'],
  error: ['notification-error'],
  warning: ['notification-warning'],
  info: ['notification-info'],
};

/** Default positions */
export const NOTIFICATION_DEFAULT_POSITION = {
  horizontal: 'center' as MatSnackBarHorizontalPosition,
  vertical: 'bottom' as MatSnackBarVerticalPosition,
};

/** Error category for GlobalErrorHandler */
export type ErrorCategory = 'fatal' | 'recoverable' | 'user-cancellation' | 'network' | 'authentication' | 'validation';

/** Categorized error for GlobalErrorHandler */
export interface CategorizedError {
  originalError: unknown;
  category: ErrorCategory;
  message: string;
  userMessage: string;
  timestamp: Date;
}

/** Spinner size options */
export type SpinnerSize = 'small' | 'medium' | 'large';

/** Spinner position options */
export type SpinnerPosition = 'center' | 'top-right' | 'bottom-left';
